import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFF8E7]" data-testid="protected-loading">
        <div className="text-sm uppercase tracking-[0.2em] font-bold text-[#1A5DFF]">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/signin" replace />;
  return children;
}
